{
  "es": {
    "ai": {
      "assistant": {
        "all_projects": "Todos los proyectos",
        "cap": {
          "action": "Iniciar una nueva conversación",
          "message": "Has alcanzado el límite de conversaciones."
        },
        "empty_state": {
          "subtitle": "Pregúntame lo que quieras sobre tus clientes",
          "title": "¿En qué puedo ayudarte?"
        },
        "errors": {
          "budget_reached": "Se ha alcanzado el presupuesto mensual de IA de este espacio de trabajo. Contacta con un administrador para aumentar el límite.",
          "generic": "Algo ha salido mal. Inténtalo de nuevo."
        },
        "history": {
          "empty": "Todavía no hay conversaciones anteriores",
          "title": "Conversaciones anteriores"
        },
        "input": {
          "disclaimer": "Los resultados pueden ser inexactos. Verifica siempre la información importante.",
          "hint": "Intro para enviar · Mayús+Intro para nueva línea",
          "placeholder": "Pregunta sobre tus clientes..."
        },
        "name": "Ziggy",
        "suggestions": {
          "help_notifications": "¿Cómo configuro las notificaciones?",
          "help_project_settings": "¿Dónde encuentro la configuración del proyecto?",
          "open_decisions": "¿Qué decisiones siguen abiertas?",
          "unassigned_units": "¿Qué unidades todavía no tienen cliente?"
        },
        "support_cta": {
          "action": "Contactar con soporte",
          "prompt": "¿No es la respuesta que buscabas?"
        }
      },
      "settings": {
        "budget": {
          "description": "Límite de coste mensual para el uso de IA (fase de prueba). Se recalcula según el uso de tokens en todas las conversaciones de este mes.",
          "free_label": "Presupuesto gratuito",
          "override_help": "Déjalo vacío para usar el importe del paquete ({amount}).",
          "override_label": "Presupuesto gratuito personalizado",
          "paid_label": "Presupuesto de pago",
          "save": "Guardar",
          "title": "Presupuesto mensual",
          "total_label": "Presupuesto total",
          "usage_label": "Usado este mes",
          "use_package_amount": "Usar el importe del paquete"
        },
        "description": "Configuración de las funciones de IA en tu espacio de trabajo.",
        "title": "Configuración de IA",
        "usage": {
          "description": "Cuánto se ha usado del saldo de IA de este mes. Al llegar al 100 %, las funciones de IA se detienen hasta que el saldo se renueve el mes que viene.",
          "title": "Uso de IA"
        }
      }
    }
  }
}
